import $ from 'jquery';
export default class Search {
    static mount() {
        $(function () {
            new Search();
        });
    }
    constructor() {
        this.$searchToogleButton = $('.wp-block-button.menu-search-toggle');
        this.$searchFormWrapper = $('.wp-block-search-wrapper');
        this.registerEvents();
    }
    registerEvents() {
        this.$searchToogleButton.on('click', (event) => {
            if (event.currentTarget === null)
                return;
            const $button = $(event.currentTarget);
            this.onToggleClick($button);
        });
    }
    onToggleClick($button) {
        this.$searchFormWrapper.toggleClass('is-active');
        setTimeout(() => {
            this.$searchToogleButton.toggleClass('is-active');
        }, 200);
        if (this.$searchFormWrapper.hasClass('is-active')) {
            this.$searchFormWrapper.find('input').trigger('focus');
        }
    }
}
